<template>
    <iframe src="https://auth.tesla.cn/oauth2/v3/authorize?response_type=code&client_id=ownerapi&redirect_uri=https%3A%2F%2Fauth.tesla.com%2Fvoid%2Fcallback&scope=openid+email+offline_access&state=VlNnSdhV14Sfvq6Wc9xYlkjV8cdjn8&code_challenge=zSjPNdsoL5yiA-MWl-5oWRkb805rOSeSDEd7bqRDy34&code_challenge_method=S256&login_hint=xuzhenxing1983%40163.com" style="width: 100%;height: 100%;bordr: 0;margin: 0;"></iframe>
</template>
<script>
import config from "@/config/index"
export default {
    name: "family",
    data() {
        return {
            imgServer: config.imgServer,
        }
    },
    methods: {}
};
</script>
